import { useMemo } from 'react';
import { TimeSignal } from 'graphql/types';
import {
  CustomLabel,
  TimesheetLabel
} from 'modules/timesheet-labels/labelSchema';
import { useIsSmartSuggestionSettingEnabled } from 'modules/timesheet-labels/hooks/useIsSmartSuggestionSettingEnabled';
import { mapTimeSignalToNoteFormData } from '../../common/utils';
import { NoteFormData } from '../../common/noteSchema';

export const useNoteFormInitialValue = ({
  timesheetLabels,
  customLabels,
  timeSignal
}: {
  timesheetLabels: TimesheetLabel[];
  customLabels: CustomLabel[];
  timeSignal: TimeSignal;
}): NoteFormData => {
  const isSmartSuggestionEnabled = useIsSmartSuggestionSettingEnabled();
  return useMemo(
    () =>
      mapTimeSignalToNoteFormData({
        timeSignal,
        timesheetLabels,
        customLabels,
        isSmartSuggestionEnabled
      }),
    [timeSignal, timesheetLabels, customLabels, isSmartSuggestionEnabled]
  );
};
